import IpsSelect from './IpsSelect.vue';
import '../../../styles/custom.scss';

export default IpsSelect;
